import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import analytics from '../../../modules/analytics';
import { useLinkTo, useMount } from '../../../hooks';
import {
  BodyText,
} from '../../ui';
import MonthlyGoalSurvey from './MonthlyGoalSurvey';
import ModalTrigger from '../../ui/ModalTrigger';
import { StarIconFilled, ChevronIcon } from '../../ui/Icons';
import Button from '../../ui/Button';

type SetAGoalBannerProps = {
  /** function to handle actions once survey is submitted */
  onSurveySubmitted: () => void;
  providerId: number;
};

const SetAGoalBanner = ({ onSurveySubmitted, providerId }: SetAGoalBannerProps) => {
  const linkTo = useLinkTo();

  useMount(() => {
    analytics.track('pro_editprofile_set_goal_viewed');
  });

  const trackBannerClicked = () => {
    analytics.track('pro_editprofile_set_goal_clicked');
  };

  return (
    <ModalTrigger
      renderModal={close => (
        <MonthlyGoalSurvey
          onSurveySubmitted={onSurveySubmitted}
          closeModal={close}
          providerId={providerId}
          linkTo={linkTo}
          source="goals"
        />
      )}
      onTriggerClick={trackBannerClicked}
      renderTrigger={open => (
        <Button
          testID="monthly-goal-banner-set-goal"
          appearance="none"
          onClick={open}
          style={{
            height: '44px',
          }}
        >
          <Inline
            alignItems="center"
          >
            <StarIconFilled />
            <Box
              paddingLeft={12}
              minHeight={44}
              justifyContent="center"
              alignItems="center"
            >
              <BodyText
                appearance="normal"
                weight="bold"
                textAlign="left"
                textTransform="none"
              >
                Set a monthly goal
              </BodyText>
            </Box>
            <ChevronIcon
              direction="right"
              color={colors.smudge}
              style={{
                marginLeft: 'auto',
              }}
            />
          </Inline>
        </Button>
      )}
    />
  );
};

export default SetAGoalBanner;
